import React, { FC } from 'react';

import { Button, useTheme } from '@mui/material';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { useBreakpointV2 } from '@helpers/use';

type NavigatorButtonMobileProps = {
  direction: 'LEFT' | 'RIGHT';
  isDisabled?: boolean;
  action?: () => void;
  ariaLabel: string;
};

const NavigatorButtonMobile: FC<NavigatorButtonMobileProps> = ({
  direction,
  isDisabled = false,
  action,
  ariaLabel,
}) => {
  const theme = useTheme();
  const { isMobile } = useBreakpointV2();

  const icon: Record<string, string> = {
    LEFT: 'fa-light fa-angle-left',
    RIGHT: 'fa-light fa-angle-right',
  };

  const iconColor = isDisabled ? theme.palette.textV2.disabled : theme.palette.primary.main;

  return (
    <Button
      sx={{
        minWidth: '35px',
        height: '35px',
        display: !isMobile ? 'none' : 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
      }}
      aria-label={ariaLabel}
      disabled={isDisabled}
      onClick={action}
    >
      <FontAwesomeIcon icon={icon[direction]} color={iconColor} />
    </Button>
  );
};

export default NavigatorButtonMobile;
